/* _processed_nuxt_unctx_transform */
import { executeAsync as __executeAsync } from "/app/node_modules/.pnpm/unctx@2.3.1/node_modules/unctx/dist/index.mjs";import { createError, showError } from "#app/composables/error";
import { useNuxtApp } from "#app/nuxt";
import { defineNuxtRouteMiddleware, useRouter } from "#app/composables/router";
export default defineNuxtRouteMiddleware(async (to) => {let __temp, __restore;
  if (!to.meta?.validate) {
    return;
  }
  const nuxtApp = useNuxtApp();
  const router = useRouter();
  const result = (([__temp,__restore]=__executeAsync(()=>Promise.resolve(to.meta.validate(to)))),__temp=await __temp,__restore(),__temp);
  if (result === true) {
    return;
  }
  if (import.meta.server) {
    return result;
  }
  const error = createError({
    statusCode: 404,
    statusMessage: `Page Not Found: ${to.fullPath}`
  });
  const unsub = router.beforeResolve((final) => {
    unsub();
    if (final === to) {
      const unsub2 = router.afterEach(async () => {
        unsub2();
        await nuxtApp.runWithContext(() => showError(error));
        window.history.pushState({}, "", to.fullPath);
      });
      return false;
    }
  });
},1);
